import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import '../App.css';
import { withTranslation } from 'react-i18next';
import { postJson, deleteJson, putJson } from '../helpers/RequestsHelper';

import ConfirmationPopup from '../components/ConfirmationPopup'
import MyFlowsStatistics from '../components/MyFlowsStatistics';
import ActiveExecutions from '../components/ActiveExecutions';

class MyFlowsListItemComponent extends Component {

    constructor(props) {
        super(props)

        this.onClick = this.onClick.bind(this)
        this.onEdit = this.onEdit.bind(this)
        this.onCopy = this.onCopy.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onSwitch = this.onSwitch.bind(this)
        this.onStopConfirmed = this.onStopConfirmed.bind(this)
    }

    state = {
        nextTimeToRun: "now",
        live: false
    }

    static getDerivedStateFromProps(props, state) {
        const data = props.data

        state.nextTimeToRun = new Date(data.nextRunAt + " UTC")

        state.myFlowId = props.data._id
        state.live = props.data.live
        state.activeExecutions = data.activeExecutions

        return state
    }

    onClick = async () => {
        this.setState({ nextTimeToRun: "now", loading: true })
        try {
            await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/run/" + this.state.myFlowId)//TODO: Load the flow to get next time or return that as a result of the run
            this.props.data.nextRunAt = new Date()
            this.setState({ loading: false })
            this.props.onUpdate()
        } catch {
            this.setState({ error: true, loading: false })
        }
    }

    onEdit() {
        this.props.history.push("/workflow/" + this.state.myFlowId);
    }

    onCopy() {
        this.props.history.push("/workflow/copy/" + this.state.myFlowId);
    }

    onSwitch = async (event) => {
        const live = event.target.checked
        if (live) {
            this.props.data.live = live
            this.setState({ 'live': live })
            await putJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/switch/" + this.state.myFlowId + "/" + live)
        } else {
            this.setState({ showStopConfirmation: true })
        }
    }

    onStopConfirmed = async () => {
        await putJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/switch/" + this.state.myFlowId + "/false")

        this.props.data.live = false
        this.setState({ 'live': false, showStopConfirmation: false })
    }


    onDelete = async (event) => {
        await deleteJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/" + event.target.dataset.flowid)
        this.props.onUpdate()
    }

    onUpdateActiveExecution = (activeExecution) => {
        const activeExecutions = this.state.activeExecutions.filter(a => a != activeExecution)
        this.setState({ activeExecutions })
        this.props.onUpdate();
    }

    render() {
        const { t } = this.props;

        //TODO: Show the difference in hours/min if it's bigger
        // Next time to run: {this.state.nextTimeToRun} 
        const data = this.props.data
        const key = "l" + this.state.loading + "s" + this.state.error
        const popupId = "popup" + this.state.myFlowId
        const hashPopupId = "#" + popupId
        const popupLabelId = "delete" + this.state.myFlowId

        var canRunManually = data.blocks.find(a => a.type === "start" && (a.application === "simplyflows_schedule" || a.application === "simplyflows_input"))
        var canBeScheduled = !data.blocks.find(a => a.type === "start" && a.application === "simplyflows_input")

        const play =
            !canRunManually ?
                <button className="btn btn-default icons-list-item" style={this.props.windowWidth > 993 ? {} : { textAlign: 'left' }} disabled={true} title={t("disabled_play")}><i className="fa fa-play" aria-hidden="true"></i></button>
                :
                this.state.loading ?
                    <div className="spinner-border" role="status">
                        <span className="sr-only"></span>
                    </div>
                    :
                    <button onClick={this.onClick} className="btn btn-default icons-list-item" style={this.props.windowWidth > 993 ? {} : { textAlign: 'left' }}><i className="fa fa-play" aria-hidden="true"></i></button>;

        const status =
            this.props.data.tested === false ?
                <span key="status" className="iconify text-danger" data-icon="carbon:ai-status-failed" data-inline="false" data-toggle="tooltip" data-placement="top" title={t("lblneedsattention")}></span>
                : this.state.error === true ?
                    <span key="status" className="iconify text-danger" data-icon="carbon:ai-status-failed" data-inline="false" data-toggle="tooltip" data-placement="top" title={t("lbllastrunfail")}></span>
                    :
                    <span key="status" className="iconify text-success" data-icon="carbon:ai-status-complete" data-inline="false" data-toggle="tooltip" data-placement="top" title={t("lbllastrunsucceed")}></span>

        const switchId = "switch" + this.state.myFlowId
        let runInfo = ""

        if (data.live) {
            // if (data.nextRunAt) {
            //     var nextRun = moment(data.nextRunAt)
            //     const nextRunAt = nextRun.isBefore(new Date()) ? "now" : nextRun.fromNow()
            //     if (data.lastRunSuccess === undefined) {
            //         runInfo += t("lblflowlastrun") + "never"
            //     } else {
            //         runInfo = t("lblflowlastrun") + moment(this.props.data.lastRunAt).fromNow()
            //         if (data.lastRunSuccess === false) {
            //             runInfo += " (fail)"
            //         }
            //     }
            //     runInfo += ", " + t("lblflownextrun") + nextRunAt
            // }
        }

        return (
            <div className="workflow-item" key={this.state.myFlowId}>

                {this.props.isLegacy ?
                    <div className="row">
                        <div className="col-1 mw-100">
                            {data.draft ? "Draft" :
                                <table className="icons-list mw-100" key={key}><tbody><tr>
                                    <td className="icons-list-item"><div className="custom-control custom-switch" data-toggle="tooltip" data-placement="top" title="Turn on/off automatic execution">
                                        <input type="checkbox" className="custom-control-input" id={switchId} onChange={this.onSwitch} checked={this.state.live === true} />
                                        <label className="custom-control-label" htmlFor={switchId}></label>
                                    </div></td>
                                    <td className="icons-list-item" data-toggle="tooltip" data-placement="top" title="Start workflow manually">{play}</td>
                                    <td className="icons-list-item" data-toggle="tooltip" data-placement="top" title="Status">{status}</td>
                                </tr></tbody></table>
                            }
                        </div>
                        <div className="col-8" onClick={this.onEdit} style={{ cursor: "pointer" }}>{data.title}</div>
                        <div className="col-2">
                            <table className="icons-list"><tbody><tr>
                                <td className="icons-list-item"><button onClick={this.onEdit} className="btn btn-default icons-list-item" data-toggle="tooltip" data-placement="top" title="Edit"><i className="fa fa-edit"></i></button></td>
                                <td className="icons-list-item"><button onClick={this.onCopy} className="btn btn-default icons-list-item" data-toggle="tooltip" data-placement="top" title="Copy"><i className="fa fa-copy"></i></button></td>
                                <td className="icons-list-item"><button data-toggle="modal" data-target={hashPopupId} className="btn btn-default icons-list-item" title="Delete"><i className="fa fa-trash"></i></button></td>
                            </tr></tbody></table>
                        </div>
                        {runInfo ?
                            <div className="col-12 info" >
                                <MyFlowsStatistics statistics={this.props.statistics} /> {runInfo}
                            </div> : null
                        }
                        {this.state.activeExecutions ?
                            <div className="col-12 info" >
                                <ActiveExecutions items={this.state.activeExecutions} onUpdate={this.onUpdateActiveExecution} workflow={data} />
                            </div>
                            : null
                        }
                    </div>
                    :
                    <div className="row" style={{ flexWrap: 'nowrap', flexDirection: 'row' }}>
                        <div className="col-2">
                            {data.draft ? "Draft" :
                                <div style={this.props.windowWidth > 993 ? { display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', height: '100%' } : { display: 'flex', flexWrap: 'nowrap', flexDirection: 'column', height: '100px' }}>
                                    <div className="custom-control custom-switch" data-toggle="tooltip" data-placement="top" title="Turn on/off automatic execution" style={{ margin: 'auto', textAlign: 'left' }}>
                                        <input type="checkbox" className="custom-control-input" id={switchId} onChange={this.onSwitch} checked={this.state.live === true} />
                                        <label className="custom-control-label" htmlFor={switchId}></label>
                                    </div>
                                    <div className="icons-list-item" data-toggle="tooltip" data-placement="top" title="Start workflow manually" style={{ margin: 'auto', textAlign: 'left' }}>{play}</div>
                                    <div className="icons-list-item" data-toggle="tooltip" data-placement="top" title="Status" style={{ margin: 'auto', textAlign: 'left' }}>{status}</div>
                                </div>
                            }
                        </div>
                        <div className="col-8" onClick={this.onEdit} style={{ cursor: "pointer" }}>{data.title}</div>
                        <div className="col-2" style={this.props.windowWidth > 993 ? { display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', justifyContent: 'flex-end', height: '100%', margin: 'auto' } : { display: 'flex', flexWrap: 'nowrap', flexDirection: 'column', height: '100px' }}>
                            <div className="icons-list-item" style={{ margin: 'auto', textAlign: 'right' }}><button onClick={this.onEdit} className="btn btn-default icons-list-item" data-toggle="tooltip" data-placement="top" title="Edit"><i className="fa fa-edit"></i></button></div>
                            <div className="icons-list-item" style={{ margin: 'auto', textAlign: 'right' }}><button onClick={this.onCopy} className="btn btn-default icons-list-item" data-toggle="tooltip" data-placement="top" title="Copy"><i className="fa fa-copy"></i></button></div>
                            <div className="icons-list-item" style={{ margin: 'auto', textAlign: 'right' }}><button data-toggle="modal" data-target={hashPopupId} className="btn btn-default icons-list-item" title="Delete"><i className="fa fa-trash"></i></button></div>
                        </div>
                        {runInfo ?
                            <div className="col-12 info" >
                                <MyFlowsStatistics statistics={this.props.statistics} /> {runInfo}
                            </div> : null
                        }

                    </div>

                }
                {this.state.activeExecutions ?
                    <div className="row" style={{ flexWrap: 'nowrap', flexDirection: 'row' }}>
                        <div className="col-12 info" >
                            <ActiveExecutions items={this.state.activeExecutions} onUpdate={this.onUpdateActiveExecution} workflow={data} />
                        </div>
                    </div>
                    : null
                }
                <div className="modal fade" id={popupId} tabIndex="-1" role="dialog" aria-labelledby={popupLabelId} aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id={popupLabelId}>{t("lblflowdelete")}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label={t("btnclose")} title={t("btnclose")}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {t("lblflowdeleteconfirm")}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="submit-btn" data-dismiss="modal" onClick={this.onDelete} data-flowid={this.state.myFlowId}>{t("btndeleteconfirm")}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <ConfirmationPopup show={this.state.showStopConfirmation}
                    title={t("warning")}
                    onConfirm={this.onStopConfirmed}
                    onHide={() => this.setState({ showStopConfirmation: false })}
                    text={t("stop_workflow_warning")}
                    buttonText={t("btn_confirm")} />
            </div>
        )
    }
}

export default withRouter(withTranslation()(MyFlowsListItemComponent), MyFlowsListItemComponent);
